module.exports = __webpack_public_path__ + "static/media/Spoonerism-MT-17.7d30f867.mp3";